import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Stack,
} from "@mui/material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import CodeIcon from "@mui/icons-material/Code";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { useTheme } from "@emotion/react";
import { requestGetAll } from "../API/request_server";
import CircularWithValueLabel from "./Loader";
import Heading from "./Heading";

export default function OurPartners() {
  const [_partners, _setPartners] = useState([]);
  const [_loader, _setLoader] = useState(false);

  const theme = useTheme();
  const getData = async () => {
    _setLoader(true);
    const result = await requestGetAll("partners/getall");
    const data = result.data.map((item) => ({
      partner_title: item.partner_title,
      icon: item.icon
        ? `https://ptp.gkp.pk/backend_ptp_admin/${item.image}`
        : //  ? `http://localhost/backend_ptp_admin/${item.icon}`
          "https://via.placeholder.com/300",
    }));
    _setPartners(data);
    _setLoader(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Box sx={{ py: 6, backgroundColor: "#f9f9f9" }}>
      <Container>
        <Heading _title="Our Partners" />

        <Grid container spacing={3} justifyContent="center">
          {_partners.map((item) => (
            <Grid item xs={6} sm={3} md={2} key={item.id}>
              <Box
                component="img"
                src={item.icon}
                alt={item.partner_title}
                sx={{
                  width: "100%",
                  height: 80,
                  objectFit: "contain",

                  transition: "0.3s",
                  "&:hover": {
                    filter: "grayscale(0%)",
                    transform: "scale(1.05)",
                  },
                }}
              />
              {/* <Typography  fontWeight={700} gutterBottom>
                                  {item.partner_title}
                                </Typography> */}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
